// Environment config, injected at BUILD TIME from the active .env.[mode] file.
// Vue CLI embeds only variables prefixed with VUE_APP_ (see .env.example for the list).
//
// This file holds NO live values, so it is safe to commit. Per-environment values live in
// gitignored .env.development / .env.preprod / .env.production. Select one via build mode:
//   npm run serve          -> mode "development" (points at preprod)
//   npm run build:preprod  -> mode "preprod"
//   npm run build:prod     -> mode "production"
//
// NOTE: every value below is client-side and ships in the browser bundle — none is secret.
// Firebase's apiKey is a public identifier; access is enforced by Security Rules + App Check.
// True server-side secrets belong in Cloud Functions (Secret Manager), never here.
module.exports = {
  firebase: {
    apiKey:            process.env.VUE_APP_FB_API_KEY,
    authDomain:        process.env.VUE_APP_FB_AUTH_DOMAIN,
    databaseURL:       process.env.VUE_APP_FB_DATABASE_URL,
    projectId:         process.env.VUE_APP_FB_PROJECT_ID,
    storageBucket:     process.env.VUE_APP_FB_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FB_MESSAGING_SENDER_ID,
    appId:             process.env.VUE_APP_FB_APP_ID,
  },
  functionBaseUrl:  process.env.VUE_APP_FUNCTION_BASE_URL,
  appCheckSiteKey:  process.env.VUE_APP_APPCHECK_SITE_KEY,
}
